var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"assignee-icon\"></span>\n<span class=\"assignee-name\"></span>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./process/ui/template/action/assignee-item.hbs
// module id = 871
// module chunks = 0